
import IconMobile from '~/components/icon/IconMobile.vue';
import IconFlytip from '~/components/icon/IconFlytip.vue';
import IconCity from '~/components/icon/IconCity.vue';
import IconVideo from '~/components/icon/IconVideo.vue';

export default {
    name: 'CrowdfundClearWasteStats',
    data() {
        return {
            stats: [
                { icon: IconMobile, title: 'App Downloads', stat: '30,000+' },
                { icon: IconFlytip, title: 'Reports', stat: '10,000+' },
                { icon: IconCity, title: 'Reports sent to', stat: '400+ Councils' },
                { icon: IconVideo, title: 'Featured On', stat: 'TV & Radio' },
            ],
        };
    },
};
